// extracted by mini-css-extract-plugin
module.exports = {"container":"Section6_container__1zTG9","about":"Section6_about__2UcJ6","title":"Section6_title__3h6JY"};